import BulkUploadDetailsSchema, { BulkUploadDetailsSchemaContract } from '../schemas/BulkUploadDetailsSchema';
import { postApi, getApi } from '../utils/Api';
import { BulkUploadGetByTypeRequestContract } from '../schemas/BulkUploadGetByTypeRequest';
import { BulkUploadTypes } from 'constants/bulkUpload';
import BulkUploadStagingDetailsSchema, { BulkUploadStagingDetailsSchemaContract } from '../schemas/BulkUploadStagingDetailsSchema';
import { getCsrfToken } from '../utils/PageVariables';



const bulkUploadsApi = {
    sendFile : (requestData: FormData) => {
        return postApi<BulkUploadDetailsSchemaContract,FormData>({
            url:`/bulk-uploads/upload-file`,
            responseSchema: BulkUploadDetailsSchema,
            requestData
        },'multipart')
    },

    fetchBulkUploadRecord : (bulkUploadId: number) => {
        return getApi<BulkUploadDetailsSchemaContract>({
            url:`/bulk-uploads/${bulkUploadId}`,
            responseSchema: BulkUploadDetailsSchema
        })
    },

    fetchBulkUploadRecordByType: (bulkUploadType: BulkUploadTypes, payrollMonth?: string) => {
      return postApi<BulkUploadDetailsSchemaContract, BulkUploadGetByTypeRequestContract>({
        url: `/bulk-uploads/get-by-type`,
        responseSchema: BulkUploadDetailsSchema,
        requestData: {
          type: bulkUploadType,
          ...(payrollMonth ? {payroll_month: payrollMonth} : {} ),
        },
      });
    },

    fetchBulkUploadStagingRecord : (bulkUploadId: number, page:number, rowLimit:number, sheet?:number) => {
        let url =`/bulk-uploads/${bulkUploadId}/execution-preview?page=${page}&page_size=${rowLimit}`
        if(sheet !== undefined && sheet >= 0){
            url = `${url}&sheet_number=${sheet}`
        }
        return getApi<BulkUploadStagingDetailsSchemaContract>({
            url,
            responseSchema: BulkUploadStagingDetailsSchema
        })
    },

    sendExecuteRequest : (bulkUploadId: number) => {
        return postApi<BulkUploadDetailsSchemaContract,{}>({
            url:`/bulk-uploads/${bulkUploadId}/execute`,
            responseSchema: BulkUploadDetailsSchema
        })
    },

    cancelBulkUpload : (bulkUploadId: number) => {
        return postApi<BulkUploadDetailsSchemaContract,{}>({
            url:`/bulk-uploads/${bulkUploadId}/cancel`,
            responseSchema: BulkUploadDetailsSchema
        })
    },

    // Returns the raw Response: this endpoint yields a file (blob), an async-job
    // descriptor (JSON), or a 422 error, so the caller handles the branching.
    // Can't use getApi here — callApi always does response.json() (Api.ts:83), which throws on the file blob.
    downloadOneTimePaymentTemplate: (payrollMonth: string) => {
        return fetch(
            `/v2/api/bulk-one-time-payment/download-template?payroll_month=${payrollMonth}`,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json, application/octet-stream, application/zip',
                    csrf: getCsrfToken() ?? '',
                },
                credentials: 'same-origin',
            },
        );
    },

    updateConfig: ({bulkUploadId, filters}: {bulkUploadId: number, filters: {shouldSendWelcomeEmail: boolean}}) => {
        return postApi<{}, {
            filters: {
                shouldSendWelcomeEmail: boolean;
            }
        }>({
        url: `/bulk-uploads/${bulkUploadId}/update-input-config`,
        requestData: {
          filters,
        },
        responseSchema: {},
        });
    },
};

export default bulkUploadsApi;